import { memo, useCallback } from "react";
import dynamic from "next/dynamic";
import List from "@/components/List";
import { useCanvasQuery } from "@/hooks";
import { CANVAS_PAGE_LIMIT } from "@/lib/constants";
import styles from "@/styles/Canvas.module.scss";
const HtmlSnippet = dynamic(() => import("@/components/HtmlSnippet"));
const Palette = dynamic(() => import("@/components/Palette"));

function CanvasStructure({ item, hiddenPrice }) {
  const { type, id } = item;
  return (
    <>
      {type === "palette" && <Palette id={id} hiddenPrice={hiddenPrice} />}
      {type === "html_snippet" && <HtmlSnippet id={id} />}
    </>
  );
}

function Canvas({ idKey, hiddenPrice, title }) {
  const { data, fetchMore, ...queryResult } = useCanvasQuery({
    variables: { idKey: idKey.toString(), offset: 0, limit: CANVAS_PAGE_LIMIT },
    nextFetchPolicy: "cache-first",
  });
  const items = data?.canvas;

  const itemComponent = useCallback(
    ({ item }) => {
      return <CanvasStructure item={item} hiddenPrice={hiddenPrice} />;
    },
    [hiddenPrice]
  );

  return (
    <div className={styles.container}>
      {title && <h1 className={styles.title}>{title}</h1>}
      <List
        items={items}
        limit={CANVAS_PAGE_LIMIT}
        {...queryResult}
        itemComponent={itemComponent}
        fetchMore={fetchMore}
      />
    </div>
  );
}
export default memo(Canvas);
